<!--
@component
MatchesWidgetEmbedPage

Route page component for the matches-widget embed.
-->

<script lang="ts">
  import Page from '$lib/components/embeds/MatchesWidget/index.svelte';
  import { stTrack } from '$lib/components/ST/index.js';
  import { homepage } from '$pkg';

  const scheduleHref = $derived(`${homepage.replace(/\/$/, '')}/schedule/`);
</script>

<div class="st-widget-header">
  <div class="head-title">
    <ul class="head-menu">
      <li>
        <div class="head-text">
          World Cup
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="12"
            viewBox="0 0 6 12"
            fill="none"
          >
            <path
              d="M0 0.666667L0.666667 0L5.54 4.87333C5.85333 5.18667 6 5.59333 6 6C6 6.40667 5.84667 6.82 5.54 7.12667L0.666667 12L0 11.3333L4.78 6.47333C5.04 6.21333 5.04 5.79333 4.78 5.53333L0 0.673334V0.666667Z"
              fill="#161616"
            />
          </svg> -->
        </div>
      </li>
      <li
        class="menu-item"
        onclick={() => stTrack('goal-of-the-day', 'wc2026-schedule-widget')}
      >
        <a
          target="_top"
          href="https://www.straitstimes.com/multimedia/graphics/2026/06/worldcup-2026-goal-of-the-day-game/index.html"
          >Goal of the day</a
        >
      </li>
      <li
        class="menu-item"
        onclick={() => stTrack('simulator', 'wc2026-schedule-widget')}
      >
        <a
          target="_top"
          href="https://www.straitstimes.com/multimedia/graphics/2025/12/worldcup-2026-simulator/index.html"
          >Reader's pick</a
        >
      </li>
      <li
        class="menu-item"
        onclick={() => stTrack('player-analysis', 'wc2026-schedule-widget')}
      >
        <a
          target="_top"
          href="https://www.straitstimes.com/multimedia/graphics/2026/06/worldcup-2026-player-analysis/index.html"
          >Player analysis</a
        >
      </li>
      <li
        class="menu-item"
        onclick={() => stTrack('moments', 'wc2026-schedule-widget')}
      >
        <a
          target="_top"
          href="https://www.straitstimes.com/multimedia/graphics/2026/06/world-cup-challenge-26-iconic-moments/index.html"
          >Historical moments</a
        >
      </li>
    </ul>
  </div>

  <Page />

  <div class="st-widget-footer">
    <div class="st-widget-source">Source: Reuters</div>
    <div onclick={() => stTrack('full-schedule', 'wc2026-schedule-widget')}>
      <a target="_top" href={scheduleHref}>
        Full schedule
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="5"
          height="9"
          viewBox="0 0 5 9"
          fill="none"
        >
          <path
            d="M1.01199 8.01199L0.0559998 7.08197L3.064 4.01999L0 0.95697L0.931 0L4.922 3.93799L1.01199 8.01199Z"
            fill="black"
          />
        </svg>
      </a>
    </div>
  </div>
</div>

<style lang="scss">
  .st-widget-header {
    padding-top: 15px;
    border-top: 3px solid #c7caca;
    z-index: 11;
    position: relative;

    .head-title {
      z-index: 12;
      position: relative;
      display: flex;

      .head-text {
        font-family: 'Curator';
        font-weight: bold;
        font-size: 18px;
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        vertical-align: middle;

        &:before {
          content: '';
          display: inline-block;
          width: 24px;
          height: 24px;
          background-image: url(data:image/png;base64,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);
          background-size: cover;
        }

        @media (min-width: 1024px) {
          font-size: 20px;
        }

        svg {
          margin-left: 5px;
        }
      }

      ul.head-menu {
        font-size: 18px;
        overflow: auto;
        white-space: nowrap;
        scrollbar-width: none;
        line-height: normal;
        color: #161616;

        li {
          display: inline-block;
          text-align: center;
          padding: 0 10px 0 15px;
          margin: 0;
          border-left: 1px solid #c0cac9;
          vertical-align: middle;
          line-height: normal;

          &:first-child {
            border-left: unset;
            padding-left: unset;
          }

          a {
            text-decoration: none;
          }
        }
      }
    }

    .st-widget-footer {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 10;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      line-height: normal;

      .st-widget-source {
        font-size: 12px;
        color: #9d9d9d;
        align-content: center;
      }

      a {
        font-size: 13px;
        text-decoration: none;
        text-decoration-color: var(--st-links);
        text-decoration-style: dotted;
        text-decoration-thickness: 1px;

        svg {
          margin-left: 5px;
        }
      }
    }
  }

  :global {
    [st-app] {
      .st-widget-header .head-title ul.head-menu {
        font-size: 16px;
      }
    }
  }
</style>
